import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Professionalstudiohero from "./sections/Professionalstudiohero";
import TuHistoriaEnUnaCanciN from "./sections/TuHistoriaEnUnaCanciN";
import NuestraMisiNInspiradora from "./sections/NuestraMisiNInspiradora";
import ElCaminoATuSonido from "./sections/ElCaminoATuSonido";
import VocesDeGratitud from "./sections/VocesDeGratitud";
import ListoParaCrear from "./sections/ListoParaCrear";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="!text-[rgba(15,23,41,1)] !bg-transparent">
      <Header />
      <Professionalstudiohero />
      <TuHistoriaEnUnaCanciN />
      <NuestraMisiNInspiradora />
      <ElCaminoATuSonido />
      <VocesDeGratitud />
      <ListoParaCrear />
      <Footer />
    </div>;
}